function getCharacterLength(str) {
  var length = 0;
  for (var i = 0; i < str.length; i++) {
    if (isChineseCharacter(str[i])) {
      length += 1;
    } else {
      length += 0.5;
    }
  }
  return length;
}

function isChineseCharacter(char) {
  return /[\u4e00-\u9fa5]/.test(char);
}

/**
 * 通过传入任意字符串和最大长度，可以得到经过截断后的字符串并显示省略号
 * @param text
 * @param maxLength
 * @returns {*|string}
 */
export default function truncateText(text, maxLength) {
  if (getCharacterLength(text) <= maxLength) {
    return text; // 如果文本长度小于或等于最大长度，直接返回
  }

  var truncatedText = '';
  var length = 0;
  for (var i = 0; i < text.length; i++) {
    if (isChineseCharacter(text[i])) {
      length += 1;
    } else {
      length += 0.5; // 非汉字字符可以根据需要调整估算的宽度
    }

    if (length > maxLength) {
      truncatedText += '...';
      break;
    } else {
      truncatedText += text[i];
    }
  }

  return truncatedText;
}
